import { PortalInstallNotice } from "./PortalInstallNotice";
import { ServiceWorkerUpdateNotice } from "./ServiceWorkerUpdateNotice";

export function PortalRuntimeNotices() {
  return (
    <div className="portal-notice-stack">
      <ServiceWorkerUpdateNotice />
      <PortalInstallNotice />
    </div>
  );
}
